<template>
    <div class="fm-tree scroll">
        <branch v-bind:parent-id="0" @selected="onPathSelected"/>
    </div>
</template>

<script>
import Branch from './BranchSelect.vue';

export default {
  name: 'FolderTreeSelect',
  components: {
    branch: Branch,
  },
  computed: {
    /**
     * Selected Disk
     * @returns {*}
     */
    selectedDisk() {
      return this.$store.getters['selectedDisk'];
    },
  },
  methods: {
    onPathSelected(event) {
      this.$emit('selected', event);
    },
  },
};
</script>

<style lang="scss">
    .fm-tree {
        padding-left: 10px;
        & > .fm-folders-tree {
            padding-left: 0.2rem;
        }

        .fm-tree-disk {
            padding: 0.2rem 0.3rem;
            margin-bottom: 0.3rem;
            background-color: white;
        }

        .fm-tree-disk > i {
            padding-left: 0.2rem;
            padding-right: 0.5rem;
        }
    }
</style>
